import { setRegisteredData } from "./registered-data";

$(function() {
    $('[data-winner-auto-show]').each(function() {
        $(this).modal('show');
    });
});

$('.winner-form').on('submit-success', function(event, data, xhr) {
    event.assert(xhr.status == 201 && data.status == 'OK');

    setRegisteredData(data, '#winnerThankModal');

    $('section#winner .s-winner__card').addClass('d-none');
    $('#winnerThankModal').modal('show');
});

$('.winner-form').on('submit-error', function(event, xhr) {
    event.preventDefault();
    if (xhr.status == 410) {
        alert('Formularz wygasł.');
    }
});

$('[name="personal_data[noPesel]"]').on('change', function() {
    $('[name="personal_data[pesel]"]', this.form.elements).prop('disabled', $(this).prop('checked'));
    let fields = [
        '[name="personal_data[street]"]',
        '[name="personal_data[streetNr]"]',
        '[name="personal_data[flatNr]"]',
        '[name="personal_data[zipCode]"]',
        '[name="personal_data[city]"]',
    ];
    $(fields.join(', '), this.form.elements).closest('.form-group').prop('disabled', !$(this).prop('checked'));
}).trigger('change');